import React, { RefObject } from "react";

import { isDefined } from "@utils/helpers";

import { StoreDirectionsInput } from "./components/input/storeDirectionsInput.container";
import { StoreDirectionsMap } from "./components/map/storeDirectionsMap.container";
import { StoreDirectionsResult } from "./components/result/storeDirectionsResult.container";
import { useStoreDirectionsContext } from "./storeDirections.context";
import "./storeDirections.scss";

type StoreDirectionsComponentProps = {
    mapElementRef: RefObject<HTMLDivElement>;
};

export const StoreDirectionsComponent = ({
    mapElementRef,
}: StoreDirectionsComponentProps) => {
    const { origin } = useStoreDirectionsContext();

    return (
        <div className={"store-directions"}>
            <StoreDirectionsMap ref={mapElementRef} />
            <div className={"store-directions__controls"}>
                {!isDefined(origin) && <StoreDirectionsInput />}
                {isDefined(origin) && <StoreDirectionsResult />}
            </div>
        </div>
    );
};
